import { createContext, JSX, useState } from 'react';
import { Spinner } from '../components/spinner/Spinner';

type TSpinnerContextType = {
    showSpinner: (opc: boolean) => void;
    spinner: JSX.Element;
}

const SpinnerContext = createContext<TSpinnerContextType>({ showSpinner: () => { }, spinner: <></> });

const SpinnerProvider = ({ children }: { children: JSX.Element }) => {
    const [spinner, setSpinner] = useState<JSX.Element>(<></>);

    const showSpinner = (opc: boolean) => {
        opc ? setSpinner(<Spinner />) : setSpinner(<></>);
    }

    return (
        <SpinnerContext.Provider value={{ spinner, showSpinner }}>
            {children}
        </SpinnerContext.Provider>
    );
}

export { SpinnerContext, SpinnerProvider };
